import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import RequestHelper from "../../../helpers/RequestHelper";
import { getGenelDurumString } from "../../../features/loadingMessageSlice";
import { getCurrentUser } from "../../../features/currentUserSlice";
import GenelDurumHelper, { GenelDurumLoginStateHelper } from "../../../helpers/GenelDurumHelper";
import { CsmText } from "../../../library/components/mui/CsmText";
import { IMainScreenProps, MainLayout } from "../../../components/layout/MainLayout";
import { Button, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import { appIcons } from "../../../app/appIcons";
import Columns from "../../../library/components/layout/Columns";
import { mainScreenLocations } from "../../../app/mainScreens";
import Cell from "../../../library/components/layout/Cell";
import Rows from "../../../library/components/layout/Rows";
import appColors from "../../../app/appColors";
import { KilitliKullaniciViewModel } from "../../../models/viewModels/KilitliKullaniciViewModel";
import AlertHelper from "../../../library/helpers/AlertHelper";
import { useTranslation } from "react-i18next";
import TranslationHelper from "../../../helpers/TranslationHelper";
import DateTimeToStringHelper from "../../../library/helpers/DateTimeToStringHelper";

function KilitliHesapYonetimScreen() {

  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const translate = TranslationHelper.TransFunc(t);
  const requestHelper = RequestHelper(navigate, dispatch, translate);

  const genelDurum = GenelDurumHelper.StringToModel(useAppSelector(getGenelDurumString)!)!;
  const user = useAppSelector(getCurrentUser);

  useEffect(() => {
    if (!user.token || genelDurum == null) {
      GenelDurumLoginStateHelper.GenelDurumYukleVeKoroAyarla(requestHelper, navigate, dispatch, user, genelDurum);
    }
  })

  if (!user.token || genelDurum == null) {
    return <></>;
  }

  const genelDurumHelper = new GenelDurumHelper(genelDurum, user, translate, navigate, dispatch, i18n, requestHelper);

  return <KilitliHesapYonetimScreenInner genelDurumHelper={genelDurumHelper} />
}

function KilitliHesapYonetimScreenInner(props: IMainScreenProps) {
  const { genelDurumHelper } = props;

  const [kullanicilar, setKullanicilar] = useState<KilitliKullaniciViewModel[]>([]);

  const yenile = async () => {
    const webResponse = await genelDurumHelper.requestHelper.Genel.KilitliKullaniciGetir();
    if (!webResponse.successfull)
      return;

    setKullanicilar(webResponse.data?.orderByDesc(e => e.kilitlenmeTarihi) ?? []);
  }

  useEffect(() => {
    yenile();
  }, []);

  const kilidiAc = async (kullanici: KilitliKullaniciViewModel) => {
    const onay = await AlertHelper.Confirm("Dikkat", `'${kullanici.kullaniciAdi}' kullanıcısının hesap kilidi açılsın mı?`);
    if (!onay)
      return;

    const webResponse = await genelDurumHelper.requestHelper.Genel.KullaniciKilidiAc(kullanici.id);
    if (!webResponse.successfull)
      return;

    await yenile();

    AlertHelper.ShowMessage("Dikkat", "Hesap kilidi açıldı");
  }

  const kullaniciTableGetir = (kullaniciList: KilitliKullaniciViewModel[]): JSX.Element => {
    return (
      <TableContainer>
        <Table size="small" sx={{ minWidth: 650 }} aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell style={{ fontWeight: "bold" }}>Kullanıcı</TableCell>
              <TableCell style={{ fontWeight: "bold" }} align="right">Ad Soyad</TableCell>
              <TableCell style={{ fontWeight: "bold" }} align="right">Korolar</TableCell>
              <TableCell style={{ fontWeight: "bold" }} align="right">Kilitlenme Tarihi</TableCell>
              <TableCell style={{ fontWeight: "bold" }} align="right">Hatalı Giriş Sayısı</TableCell>
              <TableCell style={{ fontWeight: "bold" }} align="right">İşlem</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {kullaniciList.map((kullanici) => (
              <TableRow
                key={kullanici.id}
                sx={{
                  '&:last-child td, &:last-child th': { border: 0 },
                  '&:nth-of-type(odd)': { backgroundColor: appColors.ACTION_HOVER },
                }}>
                <TableCell component="th" scope="row">{kullanici.kullaniciAdi}</TableCell>
                <TableCell align="right">{`${kullanici.ad} ${kullanici.soyad}`}</TableCell>
                <TableCell align="right">{kullanici.koroIsimler.join(", ")}</TableCell>
                <TableCell align="right">{kullanici.kilitlenmeTarihi == null ? "" : DateTimeToStringHelper.toDatetimeWithSecondsString(kullanici.kilitlenmeTarihi)}</TableCell>
                <TableCell align="right">{kullanici.hataliGirisSayisi}</TableCell>
                <TableCell align="right">
                  <Button onClick={() => kilidiAc(kullanici)}>
                    {appIcons.CrudIcons.onayla}
                    <Typography>Kilidi Aç</Typography>
                  </Button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    );
  }

  return (
    <MainLayout
      location={mainScreenLocations.kilitliHesapYonetim}
      genelDurumHelper={genelDurumHelper}
      hideHeader={false}
      hideMenu={false}>
      <Rows>
        <Columns mb={10}>
          <Cell ml={10} mt={10}>
            <Button variant="contained" onClick={() => yenile()}>
              {appIcons.Genel.search}
              <Typography>Yenile</Typography>
            </Button>
          </Cell>
        </Columns>
        <CsmText style={{ marginBottom: "10px" }} header>Kilitli Hesaplar</CsmText>
        {kullaniciTableGetir(kullanicilar)}
      </Rows>
    </MainLayout>
  );
}

export default KilitliHesapYonetimScreen;
